module.exports = __webpack_public_path__ + "sprite.21d72314c2e65e790669.png";


//////////////////
// WEBPACK FOOTER
// /Users/muhammadfiqihfirdiansyah/Documents/Muhammad Fiqih Firdiansyah/Project/Angular/BODES/BODES.Web.UI.Angular4/external_css/kendo-ui/BlueOpal/sprite.png
// module id = ../../../../../external_css/kendo-ui/BlueOpal/sprite.png
// module chunks = styles